import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import AxiosInstance from "../../components/Axios";
import MySelectField from "../../components/forms/MySelectField";
import MyTextField from "../../components/forms/MyTextField";
import MyAutocompleteField from "../../components/forms/MyAutocompleteField";
import MyDatePickerField from "../../components/forms/MyDatePickerField";
import MyMultiSelectField from "../../components/forms/MyMultiSelectField";
import dayjs from "dayjs";
import axios from "axios";
import colors from "../../components/constants/Colors";

const IPRTypeOptions = [
  "Patent",
  "Trademark",
  "Registered design",
  "Utility model",
  "Others",
];
const ApplicationReferences = ["IPFR1012", "IPTN012", "IPIT1012"];
const IPRStatus = ["Approved", "Pending", "Rejected", "N/A"];

const EditIPR = () => {
  const [partners, setPartners] = useState([]);
  const [selectedOwners, setSelectedOwners] = useState([]);
  const project_id = localStorage.getItem("project_id");
  const { id: MyId } = useParams();
  const navigate = useNavigate();

  const location = useLocation();
  const { iprData } = location.state || {};

  console.log("location ipr data", location.state);

  // Initialize form
  const { handleSubmit, setValue, control, getValues, reset } = useForm({
    defaultValues: {
      type_ipr: "",
      application_title: "",
      application_reference: "",
      application_date: null,
      ipr_owner: [],
      ipr_status: "",
      award_reference: "",
    },
    resolver: yupResolver(
      yup.object({
        type_ipr: yup.string().required("Type of IPR is a required field"),
        application_title: yup
          .string()
          .required("Application title is a required field"),
        application_reference: yup
          .string()
          .required("Application reference is a required field"),
        application_date: yup
          .date()
          .required("Application date is a required field"),
        ipr_owner: yup.array().min(1, "IPR owner is a required field"),
        ipr_status: yup.string().required("IPR status is a required field"),
        award_reference: yup
          .string()
          .required("Award reference is a required field"),
      })
    ),
  });

  useEffect(() => {
    console.log("kerData", iprData);
    if (iprData) {
      setValue("type_ipr", iprData.type_ipr);
      setValue("application_title", iprData.application_title);
      setValue("application_reference", iprData.application_reference);
      setValue("application_date", dayjs(iprData.application_date));
      setValue("ipr_status", iprData.ipr_status);
      setValue("award_reference", iprData.award_reference);
      const ownerIds = iprData.ipr_owner_details
        ? iprData.ipr_owner_details.map((owner) => owner.id)
        : [];
      setValue("ipr_owner", ownerIds);
      setSelectedOwners(iprData.ipr_owner_details || []);
    }
  }, [iprData, setValue]);

  // Fetching IPR data on mount
  // useEffect(() => {
  //   const fetchIPRData = async () => {
  //     try {
  //       const res = await AxiosInstance.get(`ipr/${MyId}`);
  //       setValue("type_ipr", res.data.type_ipr);
  //       setValue("application_title", res.data.application_title);
  //       setValue("application_reference", res.data.application_reference);
  //       setValue("application_date", dayjs(res.data.application_date));
  //       setValue("ipr_status", res.data.ipr_status);
  //       setValue("award_reference", res.data.award_reference);

  //       // Extract IDs from ipr_owner_details
  //       const ownerIds = res.data.ipr_owner_details
  //         ? res.data.ipr_owner_details.map((owner) => owner.id)
  //         : [];
  //       setValue("ipr_owner", ownerIds);

  //       // Also, set detailed owners data separately if needed
  //       setSelectedOwners(res.data.ipr_owner_details || []);
  //     } catch (error) {
  //       console.error("Error fetching IPR data:", error);
  //     }
  //   };

  //   fetchIPRData();
  // }, [MyId, setValue]);

  // Fetching partners for the project
  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await axios.get(
          ` https://eutracker.rdiup.com/v1/projects/${project_id}/get_partners/`
        );
        if (response.status === 200) {
          setPartners(response.data);
        }
      } catch (error) {
        console.error("Error fetching partners:", error);
      }
    };

    fetchPartners();
  }, [project_id]);

  // Form validation schema
  const schema = yup.object({
    type_ipr: yup.string().required("Type of IPR is a required field"),
    application_title: yup
      .string()
      .required("Application title is a required field"),
    application_reference: yup
      .string()
      .required("Application reference is a required field"),
    application_date: yup
      .date()
      .required("Application date is a required field"),
    ipr_owner: yup.array().min(1, "IPR owner is a required field"),
    ipr_status: yup.string().required("IPR status is a required field"),
    award_reference: yup
      .string()
      .required("Award reference is a required field"),
  });

  // Submission handler
  const onSubmit = async (data) => {
    const formattedDate = data.application_date
      ? dayjs(data.application_date).format("YYYY-MM-DD")
      : null;

    try {
      await AxiosInstance.put(`projects/${project_id}/ipr/${MyId}/`, {
        type_ipr: data.type_ipr,
        application_title: data.application_title,
        application_reference: data.application_reference,
        application_date: formattedDate,
        ipr_owner: data.ipr_owner,
        ipr_status: data.ipr_status,
        award_reference: data.award_reference,
      });
      navigate(`/monitoring`);
    } catch (error) {
      console.error("There was an error submitting the form!", error);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            backgroundColor: colors.secondary,
            marginBottom: "10px",
            borderTopRightRadius: 5,
            borderTopLeftRadius: 5,
          }}
        >
          <Typography sx={{ marginLeft: "20px", color: "#fff" }}>
            Edit the IPR
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            boxShadow: 3,
            padding: 4,
            flexDirection: "column",
            marginTop: -1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MySelectField
              label="Type of IPR"
              name="type_ipr"
              control={control}
              width={"30%"}
              options={IPRTypeOptions}
            />
            <MyTextField
              label="Application title"
              name="application_title"
              placeholder="Provide a title"
              control={control}
              width={"30%"}
              marginTop={15}
            />
            <MyTextField
              label="Application reference"
              name="application_reference"
              placeholder="Provide a reference"
              control={control}
              width={"30%"}
              marginTop={15}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MyDatePickerField
              label="Application Date"
              name="application_date"
              control={control}
              width={"30%"}
            />
            <FormControl sx={{ width: 250 }} fullWidth>
              {partners.length > 0 && (
                <Controller
                  name="ipr_owner"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      multiple
                      options={partners}
                      getOptionLabel={(option) =>
                        `${option.name} (${option.pic})`
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Add existing partners" />
                      )}
                      onChange={(event, value) => {
                        // Update the selected owners in the form
                        const ids = value.map((owner) => owner.id);
                        setValue("ipr_owner", ids);
                        setSelectedOwners(value); // Update local state
                      }}
                      value={selectedOwners} // Use local state to display selected owners
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      fullWidth
                    />
                  )}
                />
              )}
            </FormControl>
            <MySelectField
              label="IPR Status"
              name="ipr_status"
              control={control}
              width={"30%"}
              options={IPRStatus}
            />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <MyTextField
              label="APR Award Reference ID"
              name="award_reference"
              placeholder="Provide an award reference"
              control={control}
              width={"30%"}
            />
            <Box sx={{ width: "30%" }}>
              <Button
                variant="contained"
                type="submit"
                sx={{ width: "100%", backgroundColor: colors.secondary }}
              >
                Update
              </Button>
              <Button
                variant="contained"
                onClick={() => navigate("/")}
                sx={{ width: "100%", backgroundColor: colors.secondary, mt: 2 }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </form>
    </div>
  );
};

export default EditIPR;
